import Header, { MenuOptions } from "../../Global/Header/Header";
import Footer from "../../Global/Footer/Footer";
import DesktopCategoryFilter from "../../Global/DesktopCategoryFilter/DesktopCategoryFilter";
import MonthlyTripCards from "./MonthlyTripCards/MonthlyTripCards";
import classes from "./ExploreTrips.module.css";
import Dropdown from "../../Global/customDropdown/Dropdown";

export const ExploreTripsView = ({
  showLoader,
  tripMonthHandler,
  monthOptionsArr,
  tripDataHandler,
  selectedMonth,
  firstTripList,
  secondTripList,
  thirdTripList,
  firstMonthName,
  secondMonthName,
  thirdMonthName,
  months,
  monthlyTrips,
  selectedCategory,
}) => {
  return (
    <>
      <div>
        <Header activeTab={MenuOptions.EXPLORE_TRIPS} />
        <div className={classes["entry-div"]}>
          <img
            src="https://static.wixstatic.com/media/da937f_3ce6d8bd31da4b2b8fd7a77693fe5ac6~mv2.webp"
            alt="Entry content"
            className={classes["entry-img"]}
          />
          <div className={classes["entry-things"]}>
            <p className={classes["entry-heading"]}>
              Explore <span style={{ color: "#e65439" }}>Trips</span>
            </p>
          </div>
        </div>
        <div className={classes["mobile-filter-container"]}>
          <Dropdown
            tripDataHandler={tripMonthHandler}
            options={monthOptionsArr}
            plc={"Select Month"}
          />
        </div>
        <div className={classes["desktop-filter-container"]}>
          <DesktopCategoryFilter
            tripDataHandler={tripDataHandler}
            tripMonthHandler={tripMonthHandler}
            dropdownOptions={monthOptionsArr}
            selectedCategory={selectedCategory}
          />
        </div>
        {showLoader && (
          <div className="flex flex-col items-center justify-center h-96 bg-red-50 bg-opacity-50 dark:bg-red-50">
            <div
              className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
              role="status"
            ></div>
            <p className="mt-4 text-lg font-semibold text-gray-700 dark:text-gray-300">
              Loading ...
            </p>
          </div>
        )}
        {!showLoader && monthlyTrips && months.map((m) => {
          if(monthlyTrips[m.month.slice(0,3)])
          return (
            <>
            {monthlyTrips[m.month.slice(0,3)].length>0 && <MonthlyTripCards
              tripData={monthlyTrips[m.month.slice(0,3)]}
              monthName={m.month}
              selectedMonth={selectedMonth}
              selectedCategory={selectedCategory}
            />}
            </>
          )
        })}
        {/* {!showLoader && firstTripList.length > 0 && (
          <MonthlyTripCards
            tripData={firstTripList}
            monthName={firstMonthName}
            selectedMonth={selectedMonth}
          />
        )}
        {!showLoader && secondTripList.length > 0 && (
          <MonthlyTripCards
            tripData={secondTripList}
            monthName={secondMonthName}
            selectedMonth={selectedMonth}
          />
        )}
        {!showLoader && thirdTripList.length > 0 && (
          <MonthlyTripCards
            tripData={thirdTripList}
            monthName={thirdMonthName}
            selectedMonth={selectedMonth}
          />
        )} */}

        <Footer />
      </div>
    </>
  );
};
